import React from 'react'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import { InfoFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/InfoFillIcon'
import omit from 'lodash/omit'
import { messages } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsList/components/LoanProduct/components/LoanProductCollapsing/LoanProductOrder/components/LoanProductOrderForm/messages'
import type { TFinancingOfferModalStepsAdapter } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsList/components/LoanProduct/components/LoanProductCollapsing/LoanProductOrder/components/LoanProductOrderForm/types'

export const widgetFinancingOfferStepsAdapter: TFinancingOfferModalStepsAdapter = (steps, context, onClickConsult, isLoading = false) =>
  steps.map(step => ({
    ...step,
    title: undefined,
    titleId: undefined,
    fields: step.fields.map(field => {
      const controlledField = { ...field }

      if (field.fieldType === 'checkbox' || field.fieldType === 'policyAgreement')
        return omit(controlledField, ['activeControlStyle', 'borderColorStyle', 'markColor'])

      if (field.fieldType === 'infoText')
        return {
          ...field,
          className: 'loanProductOrderForm__infoText',
          iconProps: {
            className: 'loanProductOrderForm__infoIcon',
            style: { color: EColor.GREEN },
            component: <InfoFillIcon />,
          },
        }

      if (field.name === 'loanAmount.value') return { ...controlledField, shouldBeTouchedBeforeError: true }

      return controlledField
    }),
    calcButton: {
      modifiers: ['outline-gray', 'full-width-mobile'],
      textId: messages.actions.requestConsult,
      onClick: onClickConsult,
    },
    submitButton: {
      ...step.submitButton,
      modifiers: ['green', 'full-width-mobile'],
      loaderProps: {
        isVisible: isLoading,
      },
    },
  }))
